import React, { useState, useEffect } from 'react';
import PerinHealthGrid from '../../components/PerinHealthGrid';
import { resetFilterState } from '../../slicers/FilterSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useAxios from '../../services/AxiosConfig';
import FilterManagementView from '../../components/FilterManagementView';
import managementStyles from '../ManagementPages.module.css';
import { setPatient, resetSecurityState } from './SecurityManagementSlice';

const SecurityManagement = () => {
  const dispatch = useDispatch();
  const axiosConfig = useSelector((state) => state.axiosConfig);
  const httpService = useAxios(axiosConfig.envURL);
  const userDateFormat = useSelector((state) => state.userInfo.dateFormat);
  const userId = useSelector((state) => state.userInfo.id);

  useEffect(() => {
    dispatch(resetSecurityState());
  }, []);

  const navigate = useNavigate();

  const headers = [
    { key: 'id', label: "ID" },
    { key: 'patient', label: "Name" },
    { key: 'groups', label: 'Group', sortable: true },
    { key: 'subGroups', label: "Location", sortable: true },
    { key: 'teams', label: "Teams", sortable: true }
  ];

  const [patients, setPatients] = useState([]);
  useEffect(() => {
    getPatients();
  }, [userDateFormat]);

  const getPatients = async () => {
    dispatch(resetFilterState());
    httpService.get(`enrollment/list/patient/${userId}`)
      .then((responseData) => { 
        if (Array.isArray(responseData.data.data)) {
          const userIdSet = new Set();
          let newFormattedPatientList = [];
          newFormattedPatientList = responseData.data.data.reduce((acc, user) => {
            if (!userIdSet.has(user.id)) {
              userIdSet.add(user.id);
              let groups = [];
              let subGroups = [];
              let teams = [];
              let groupIds = [];
              let subGroupIds = [];
              let teamIds = [];
              let organizationIds = [];
              if (user.groups) {
                user.groups.forEach(group => {
                  if (group.groupName && !groups.includes(group.groupName)) {
                    groups.push(group.groupName);
                    groupIds.push(group.groupId);
                  }
                  if (group.subGroupName && !subGroups.includes(group.subGroupName)) {
                    subGroups.push(group.subGroupName);
                    subGroupIds.push(group.subGroupId);
                  }
                  if (group.teamName && !teams.includes(group.teamName)) {
                    teams.push(group.teamName);
                    teamIds.push(group.teamId);
                  }
                  if (group.organizationId) {
                    organizationIds.push(group.organizationId);
                  }
                });
              }

              acc.push({
                ...user,
                groups: groups, 
                subGroups: subGroups, 
                teams: teams,
                organizationIds: organizationIds,
                groupIds: groupIds,
                subGroupIds: subGroupIds,
                teamIds: teamIds,
                patient: user.lastName + ", " + user.firstName,
                fullName: user.firstName + " " + user.lastName
              });

            }
            return acc;
          }, []);
          setPatients(newFormattedPatientList);
        } else {
          console.error('Invalid data format:');
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onRowClickHandler = (rowItem) => {
    dispatch(setPatient(rowItem));
    navigate('/patient-security');
  };



  return (
    <div className={managementStyles.MiddleContent}>
      <FilterManagementView
        isOrganization={true}
        isGroup={true}
        isSubGroup={true}
        isTeam={true}
        showAddButton={false}
        showDeleteButton={false}
      />
      <div className={managementStyles.GridContainer}>
        <PerinHealthGrid
          dataList={patients}
          accounts={true}
          headers={headers}
          showCheckbox={true}
          showEditIcon={false}
          onRowValueClick={onRowClickHandler}
          showHeaderFilter={true}
          gridHeight="100%"
          rowValueAction={'patient'}
          useChips={true}
          showProfilePicture={"patient"}
        />
      </div>
    </div>
  );
};

export default SecurityManagement;
